import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AdminRouter from "./src/routes/admin.routes";
import CommonRouter from "./src/routes/common.routes";
import FullpageLoader from "./src/components/FullPageLoader";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import ErrorBoundry from "./src/HoC/ErrorBoundry";

const App = () => {
  const role = useSelector((data) => data.auth?.currentUser?.role);
  let router;
  if (role != undefined) {
    switch (role) {
      case "Admin":
        router = createBrowserRouter([...AdminRouter, ...CommonRouter]);
        break;
      default:
        break;
    }
  } else {
    router = createBrowserRouter([...CommonRouter]);
  }

  return (
    <>
      <Suspense fallback={<FullpageLoader />}>
        <ErrorBoundry />
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          theme="dark"
        />
        <RouterProvider router={router} />
        <ErrorBoundry />
      </Suspense>
    </>
  );
};
export default App;
